import * as React from 'react'
import { SVGProps } from 'react'
const SvgCamera = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M49 13.397h-7.731a.875.875 0 0 1-.767-.451L38.356 9.06a6.127 6.127 0 0 0-5.361-3.163h-9.99a6.125 6.125 0 0 0-5.361 3.163l-2.146 3.885a.875.875 0 0 1-.766.451H7a6.132 6.132 0 0 0-6.125 6.125v24.455A6.132 6.132 0 0 0 7 50.102h42a6.132 6.132 0 0 0 6.125-6.125V19.522A6.132 6.132 0 0 0 49 13.397Zm.875 30.578a.875.875 0 0 1-.875.875H7a.875.875 0 0 1-.875-.875V19.522A.875.875 0 0 1 7 18.647h7.732a6.125 6.125 0 0 0 5.361-3.162L22.24 11.6a.875.875 0 0 1 .767-.452h9.989a.875.875 0 0 1 .766.45l2.145 3.885v.002a6.125 6.125 0 0 0 5.363 3.162H49a.875.875 0 0 1 .875.875v24.455-.002Z"
      fill="#00D37E"
    />
    <path
      d="M28 19.375c-6.272 0-11.375 5.103-11.375 11.375S21.728 42.125 28 42.125s11.375-5.103 11.375-11.375S34.272 19.375 28 19.375Zm0 17.5a6.132 6.132 0 0 1-6.125-6.125A6.132 6.132 0 0 1 28 24.625a6.132 6.132 0 0 1 6.125 6.125A6.132 6.132 0 0 1 28 36.875Z"
      fill="#00D37E"
    />
  </svg>
)
export default SvgCamera
